/**
 * Error Boundary Component
 * Catches React errors and displays a fallback UI instead of crashing the app
 * Extends BaseErrorBoundary for shared error handling logic
 */

import { ReactNode } from 'react';
import { ErrorPage } from '@midi-volca-drum/ui-components';
import { BaseErrorBoundary } from './BaseErrorBoundary';

interface ErrorBoundaryProps {
  children: ReactNode;
}

export class ErrorBoundary extends BaseErrorBoundary<ErrorBoundaryProps> {
  protected logError(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('React Error Boundary caught an error:', error, errorInfo);
  }

  private handleReload = (): void => {
    window.location.reload();
  };

  protected renderError(): ReactNode {
    return (
      <ErrorPage
        error={this.state.error}
        actionButton={
          <button className='btn btn-primary' onClick={this.handleReload}>
            Reload Application
          </button>
        }
      />
    );
  }
}
